import React from "react";
import ReactDOM from "react-dom";
import FontFaceObserver from "fontfaceobserver";
import { addLocaleData } from "react-intl";
import * as en from "react-intl/locale-data/en";
import * as nl from "react-intl/locale-data/nl";

import App from "./screens/app";

import "./screens/app/styles/global.scss";
import {
  compareAppVersionsAndClearLocalStorageIfDifferent,
  configurationsFromFile,
} from "./apiUtils";

addLocaleData(en.default);
addLocaleData(nl.default);
compareAppVersionsAndClearLocalStorageIfDifferent();
configurationsFromFile();

ReactDOM.render(<App />, document.getElementById("application"));

const ubuntuFontObserver = new FontFaceObserver("Ubuntu", {});

ubuntuFontObserver.load().then(() => {
  document.body.classList.add("font-loaded");
});
